import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { notificationDataUser, notificationDataReadAdmin, notificationDataAdmin, notificationDataReadUser } from '../../services/api/user'
import { GetLocalStorageParsed } from '../../Utils/Utils'
import AdminDashboard from '../../pages/Admin/AdminDashboard/AdminDashboard'
import Dashboard from '../../pages/Dashboard/Dashboard'
import { useLanguage } from '../LanguageProvider/LanguageProvider '
import { capitalizeFirstLetter, formatDateTimeWithSlash, formatDateWithSlash } from '../../Utils/common'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';

const Notification = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [notificationDetails, setNotificationDetails] = useState([]);
    const [notificationFrom, setNotificationFrom] = useState('')
    const userDetail = GetLocalStorageParsed("userDetail");
    const { language, setLanguage } = useLanguage();


    useEffect(() => {
        if (location?.state) {
            setNotificationFrom(location?.state)
        }
        const fetchNotification = async () => {
            try {

                const payload = new FormData()
                if (location?.state == "user") {
                   
                    payload.append('user_id', userDetail?.id)
                    // payload.append('district_id', userDetail?.district);
                    // payload.append("user_type", 1);
                    const response = await notificationDataUser(payload);
                    //console.log(" response.data", response)
                    const data = response.data;
                    if (response.status == 200) {
                        setNotificationDetails(data);
                        markAllAsRead(location?.state)
                    } else {
                        setNotificationDetails([]);
                    }
                } else {
                    payload.append('admin_id', userDetail?.id)
                    payload.append('district_id', userDetail?.district)
                    payload.append('role', userDetail?.roles)
                    const response = await notificationDataAdmin(payload)
                    const data = response.data;
                    if (response.status == 200) {
                        setNotificationDetails(data);
                        markAllAsRead(location?.state)
                    } else {
                        setNotificationDetails([]);
                    }
                }
            } catch (error) {
                setNotificationDetails([]);
            }
        };
        fetchNotification();
    }, [location?.state])

    const markAllAsRead = async (pageFrom) => {
        try {
            const payload = new FormData()
            if (pageFrom == "user") {
                payload.append('user_id', userDetail?.id)
                const data = await notificationDataReadUser(payload);
            } else {
                payload.append('admin_id', userDetail?.id)
                payload.append('district_id', userDetail?.district)
                payload.append('role', userDetail?.roles)
                const data = await notificationDataReadAdmin(payload);
            }
        } catch (error) {
            //console.error('Failed to mark notifications as read:', error);
        }
    };

    const notificationString = (data) => {
        try {
            if (typeof JSON.parse(data) == "object") {  
                const str = JSON.parse(data);
                // //console.log(str)
                return `${capitalizeFirstLetter(str?.role || "")} ${str?.message || ""} ${str?.AdminRemark ? str?.AdminRemark : ""
                    } ${str?.pendingDocs && str?.pendingDocs != '[]'  && str?.pendingDocs != '[null]' ? str?.pendingDocs?.replace(/\[/g, '(')?.replace(/\]/g, ')')?.replace(/"/g, '')?.replace(/,/g, ', ')?.replace("(null,", "(")?.replace(",null)", ")")?.replace(",null,", ",") : ''}`;
            }
        } catch (error) {
            // //console.log(error)
            // If JSON.parse fails, it's a normal string
            return data;
        }
    }
    return (
        <>
            {
                notificationFrom == 'user' ? (
                    <Dashboard
                        first={language ? "होम" : "Home"}
                        second={language ? "अधिसूचना" : "Notification"}
                        head={language ? "अधिसूचना" : "Notification"}
                    >
                     
                            <div className="adm-tabs-outer d-flex justify-content-between d-md-flex justify-content-between">
                            <h4 className="mb-0 w-100">{language ? "सूचनाएं" : "Notifications"}</h4>
                                <div className="suf-input-box aod-form-input mb-2 ms-3 w-50">
                                </div>
                            </div>
                            {/* <div className="aod-head"></div> */}
                            <div className="row g-2 mt-2">
                                <div className=" mt-3  user_card_h noti_card_s">
                                    {notificationDetails.length > 0 ? (
                                    notificationDetails?.sort((a, b) => new Date(b?.created_at) - new Date(a?.created_at)).map((item, index) => (
                                            <div className="" key={index + 1}>
                                                <div className="col-md-12 flex-wrap detail_card_desc ">
                                                    <div className="notifi_wrapper">
                                                        <div className="notifi_left_wrapper">
                                                            <div className="bell_icon">
                                                              
                                                                <div className="notification-detail">
                                                                    <p className="notification_d"><FontAwesomeIcon icon={faBell} className='mx-2 b-icon' />
                                                                       
                                                                        {language ? notificationString(item?.remark_hi) : notificationString(item?.remark_en)}
                                                                        
                                                                        </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="notifi_right_wrapper">
                                                            {formatDateTimeWithSlash(item?.created_at)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))) :
                                        (
                                            <div className="notification-ui_dd-content">
                                                <div className="card-body">
                                                    <div className="notification-detail">
                                                        <p>{language ? 'कोई सूचना नहीं' : "No notification"} </p>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                </div>
                            </div>
                    
                    </Dashboard>
                ) : notificationFrom == 'admin'? (
                        <AdminDashboard>
                            <div className="aod-outer adminNotification">
                                <div className="aod-inner pt-0">
                                    <div className="aod-bottom">
                                        <div className="adm-tabs-outer d-flex justify-content-between d-md-flex justify-content-between">
                                            <h4 className="mb-0 w-100">Notifications</h4>
                                        </div>
                                        <div className="aod-head"></div>
                                        <div className="row g-2 mt-2">
                                            <div className=" mt-3  user_card_h noti_card_s">
                                                {notificationDetails.length > 0 ? (
                                                    notificationDetails?.sort((a, b) => new Date(b?.created_at) - new Date(a?.created_at)).map((item, index) => (
                                                        <div className="" key={index + 1}>
                                                            <div className="col-md-12 flex-wrap detail_card_desc ">
                                                                <div className="notifi_wrapper">
                                                                    <div className="notifi_left_wrapper">
                                                                        <div className="bell_icon">

                                                                            <div className="notification-detail">
                                                                                <p className="notification_d"><FontAwesomeIcon icon={faBell} className='mx-2 b-icon' />{notificationString(item?.remark_en)}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="notifi_right_wrapper">
                                                                        {formatDateTimeWithSlash(item?.created_at)}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))) :
                                                    (
                                                        <div className="notification-ui_dd-content">
                                                            <div className="card-body">
                                                                <div className="notification-detail">
                                                                    <p>No notification </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </AdminDashboard>
                ) : ''}

        </>
    )
}

export default Notification